// extracted by mini-css-extract-plugin
export default {"userFilesSelectDeleteButton":"UserFilesSelectControl_userFilesSelectDeleteButton__+NJwE"};